import * as THREE from "three";
import { createLabel } from "../../TOOLS/LabelFactory";
import { Colleague } from "./ENTITIES/Colleague"

export class ColleagueSpawner {

    constructor(store, levelController) {
        this.store = store;
        this.levelController = levelController;
        this.activeUsers = null;
        this.district = null;
        this.users = null;
        this.spawnId = 0;
    }


    async spawn() {
      const id = ++this.spawnId;
      this.clear();
      //FG - HO
      this.activeUsers = await this.store.datas.filter('USERS', 'role', 'active');
      if (id !== this.spawnId) return;
      this.district = await this.store.datas.findOne('CITIES', 'district', this.store.level.selectedDistrict);
      if (id !== this.spawnId) return;
      this.users = await this.store.datas.filter(this.activeUsers, 'districtid', parseInt(this.district.districtid));
      if (id !== this.spawnId) return;
      //az office.update nézi az animációhoz
      this.store.colleaguesByOfficeId = this.users;
      if (this.store.level.selectedOffice.label === "Nyíregyháza") {this.users = this.users.filter(user => user.job === this.store.level.colleagueFilter);}
      if (this.location) {
        this.location.parent?.remove(this.location);
        this.location = null;
      }
      // kör kiszámítása
      const count = this.users.length;
      const t = Math.min(1, Math.max(0, (count - 6) / (20 - 6)));
      const radiusY = this.store.config.isSmall ? 2 + t * 0.6 : 1.5 + t * 0.7;
      const radiusX = this.store.config.isSmall ? radiusY + t * 2.4 : radiusY + t * 1.0;
      this.store.level.spawnRadiusX = radiusX;
      this.store.level.spawnRadiusY = radiusY;
      // FG - HO
      if (this.store.level.selectedOffice.label === "Nyíregyháza") {
        const switchGroup = new THREE.Group();
        const label = this.store.level.colleagueFilter === "FG" ? "Lássam a központi dolgozókat" : "Lássam a falugazdászokat";
        this.switchLabel = createLabel(label, {fontSize: 46, width: 2, height: 0.4, position: new THREE.Vector3(0, 0, 0)});
        this.switchLabel.userData.type = "JOB_SWITCH";
        this.switchLabel.userData.instance = this.switchLabel;
        this.switchLabel.position.y -= 1;
        const background = new THREE.Mesh(
        new THREE.PlaneGeometry(2, 0.4),
        new THREE.MeshBasicMaterial({color: 0xF5A327, transparent: true, opacity: 0.45, depthWrite: false}));
        background.position.z = -0.01;   // a felirat mögé
        background.position.y = this.switchLabel.position.y;
        switchGroup.add(background);
        switchGroup.add(this.switchLabel);
        switchGroup.userData.instance = switchGroup;
        this.store.level.selectedOffice.colleagueGroup.add(switchGroup);
        this.store.input.clickables.push(this.switchLabel);
      }
    
      // +2: Települések ikon + Új bútor ikon
      const slots = this.users.length + 2;
      //települések
      this.location = this.store.assetManager.getModel("location");
      this.location.userData.type = "OFFICES";
      this.location.userData.headOffice = this.store.level.selectedOffice.label;
      this.location.userData.instance = this.location;
      this.location.scale.set(.8, .8, .8);
      const locationLabel = createLabel("Irodák", {fontSize: this.store.config.isSmall ? 16 : 16, position: new THREE.Vector3(0, -.3, 0)});
      locationLabel.raycast = () => {};
      this.location.add(locationLabel);
      const locationAngle = 0;
      this.location.position.set(Math.cos(locationAngle) * radiusX, Math.sin(locationAngle) * radiusY, 0);
      if (!this.store.input.clickables.includes(this.location)) {this.store.input.clickables.push(this.location);}
      this.store.level.selectedOffice.colleagueGroup.add(this.location);
      //új
      const plusTexture = new THREE.TextureLoader().load("/assets/plus.png");
      plusTexture.colorSpace = THREE.SRGBColorSpace;
      this.newFurniture = new THREE.Group();
      this.newFurniture.userData.type = "PLUS";
      this.newFurniture.userData.action = "new";
      this.newFurniture.userData.instance = this.newFurniture;
      const plusMaterial = new THREE.SpriteMaterial({map: plusTexture, transparent: true});
      const plusSprite = new THREE.Sprite(plusMaterial);
      plusSprite.scale.set(this.store.config.isSmall ? 1.0 : 0.8, this.store.config.isSmall ? 1.0 : 0.8, 1);
      this.newFurniture.add(plusSprite);
      const plusLabel = createLabel("Új létrehozása", {fontSize: this.store.config.isSmall ? 16 : 16, position: new THREE.Vector3(0, -.6, 0)});
      plusLabel.raycast = () => {};
      this.newFurniture.add(plusLabel);
      const plusAngle = (1 / slots) * Math.PI * 2;
      this.newFurniture.position.set(Math.cos(plusAngle) * radiusX, Math.sin(plusAngle) * radiusY, 0);
      if (!this.store.input.clickables.includes(this.newFurniture)) {this.store.input.clickables.push(this.newFurniture);}
      this.store.level.selectedOffice.colleagueGroup.add(this.newFurniture);
      //Kollégák hozzáadása
      this.users.forEach((coll, index) => {
        const angle = ((index + 2) / slots) * Math.PI * 2;
        const targetX = Math.cos(angle) * radiusX;
        const targetY = Math.sin(angle) * radiusY;
        const targetPosition = new THREE.Vector3(targetX, targetY, 0);
        const startPosition = new THREE.Vector3(0, 0, 0);
        const colleague = new Colleague(this.store, this.store.level.selectedOffice.colleagueGroup, coll.name, coll.id, startPosition.clone(), coll.picture);
        colleague.targetPosition = targetPosition;
        colleague.startTime = performance.now() + 100 + index * 100;
        colleague.animationDuration = 200;
        this.store.level.selectedOffice.colleagues.push(colleague);
      });
    }

    clear() {
        this.store.entities.offices.forEach((office) => {
        if (!office.colleagues) return;
          office.colleagues.forEach((colleague) => {colleague.dispose();});
          office.colleagues = [];
        });
        this.store.colleaguesByOfficeId = [];
        //location eltávolítása
        if (this.location) {
          this.location.parent?.remove(this.location);
          this.location = null;
        }
        //newfurniture eltávolítása
        if (this.newFurniture) {
          this.store.input.clickables = this.store.input.clickables.filter(item => item !== this.newFurniture);
          this.newFurniture.parent?.remove(this.newFurniture);
          this.newFurniture = null;
        }

        //FG - HO   
        if (this.switchLabel) {
          this.store.input.clickables = this.store.input.clickables.filter(item => item !== this.switchLabel);
          this.switchLabel.parent?.remove(this.switchLabel);
          this.switchLabel = null;
        }

        //OTHERS
        if (this.store.others) {
          this.store.others.colleagues.forEach(colleague => colleague.dispose());
          this.store.others.colleagues = [];
      }
    }
}